import { ROUTES, SYSTEM_VIEW, STORAGE_KEYS } from "const";
import * as TerminalHelper from "./TermialHelper";
import ShopsHelper from "./ShopsHelper";
import * as SalespersonHelper from "./SalespersonHelper";
import * as AppSettingsHelper from "./AppSettingsHelper";

export function getPosHomePageRoute() {
  const terminalSettings = TerminalHelper.getTerminalSettings();
  const systemType = terminalSettings?.systemType;
  const isTableDashboardEnabled = terminalSettings?.isTableDashboardEnabled;
  const isOrderDashboardEnabled = terminalSettings?.isOrderDashboardEnabled;
  const shopProfile = ShopsHelper.getCachedShopProfile();
  const hasFullKotValidity = ShopsHelper.hasFullKotValidity(shopProfile);

  if (systemType === SYSTEM_VIEW.ERP) {
    return ROUTES.ERP_DASHBOARD;
  } else if (isTableDashboardEnabled && hasFullKotValidity) {
    return ROUTES.TABLE_DASHBOARD;
  } else if (isOrderDashboardEnabled) {
    return ROUTES.ACTIVE_ORDERS;
  } else {
    return ROUTES.SALES;
  }
}

export async function getNextPosRoute() {
  const shopId = localStorage.getItem(STORAGE_KEYS.SHOP_ID);
  if (!shopId) return ROUTES.SELECT_SHOP;

  const terminalId = localStorage.getItem(STORAGE_KEYS.TERMINAL_ID);
  if (!terminalId) return ROUTES.COUNTER;

  const isBillDone = await AppSettingsHelper.isBillSetupCompleted();
  if (!isBillDone) return ROUTES.BILL_NUMBER;

  const terminalSettings = TerminalHelper.getTerminalSettings();
  const isSalespersonLogin = !!terminalSettings?.salespersonLogin;
  const currentSalesperson = SalespersonHelper.getCurrentSalesperson();

  if (isSalespersonLogin && !currentSalesperson) {
    return ROUTES.LOCK_SCREEN;
  }

  const shiftId = localStorage.getItem(STORAGE_KEYS.SHIFT_ID);
  if (!shiftId) return ROUTES.SHIFT;

  return getPosHomePageRoute();
}

export async function navigateToNextPosStep(navigate, options = {}) {
  const nextRoute = await getNextPosRoute();
  navigate(nextRoute, options);
  return nextRoute;
}
